module.exports = __webpack_public_path__ + "static/bg-d60b72160ec9bf6ffb7c4794065a521c.png";